import { useStaticUrls } from 'platform-components';
import React from 'react';

import { useSelector } from 'react-redux';
import { useRouteMatch } from 'react-router';
import { TeacherHeader } from 'common.components/TeacherHeader/TeacherHeader';
import { getIsCurrentClassArchived } from 'common.components/user/selectors';

interface Props {
    classId: number | string;
}

const ClassHeader = ({ classId }: Props) => {
    const { labClassExamsResults } = useStaticUrls();
    const isExamsResults = useRouteMatch(labClassExamsResults);

    const isArchiveClass = useSelector((storeState) => getIsCurrentClassArchived(storeState, { classId }));

    return <TeacherHeader hideRightControls={!isExamsResults} isMenuDisabled={isArchiveClass} />;
};

export default ClassHeader;
